import Link from "next/link";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SafeImage from "@/components/SafeImage";

const TRUST_DATA = [
  {
    title: "Experienced Leadership",
    desc: "Guided by Dr. Kunal G. Padole with 16+ years of excellence.",
  },
  {
    title: "Customer-Centric",
    desc: "Every aspect is designed keeping the homebuyer in mind.",
  },
  {
    title: "Quality Standards",
    desc: "Stringent quality checks at every phase of construction.",
  },
  {
    title: "Timely Delivery",
    desc: "Committed to delivering your dream home on schedule.",
  },
];

function AboutUsStyleTwo({ sectionSpace }) {
  return (
    <>
      <div className={`ltn__about-us-area ${sectionSpace}`}>
        <Container>
          <Row className="align-items-stretch">
            <Col xs={12} lg={6} className="align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-30">
                  <span className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    Why Choose Us
                  </span>
                  <h2 className="section-title">
                    Why Homebuyers Trust Us
                  </h2>
                  <p>
                    We deliver quality homes with transparent processes, trusted expertise, and timely project delivery.
                  </p>
                </div>
                <ul className="ltn__list-item-1 ltn__list-item-1-before clearfix">
                  <li><b>Experienced Leadership</b>
                    <p>Guided by Dr. Kunal G. Padole with 16+ years of experience in residential construction and development.</p>
                  </li>

                  <li><b>Customer-Centric Approach</b>
                    <p>Every aspect of our residential projects is thoughtfully planned around the needs, comfort, and expectations of homebuyers.</p>
                  </li>

                  <li><b>Quality Construction Standards</b>
                    <p>We follow stringent quality checks, premium materials, and skilled craftsmanship at every stage of construction.</p>
                  </li>

                  <li><b>Timely Project Delivery</b>
                    <p>We are committed to on-time delivery of quality homes, helping homebuyers move into their dream homes as planned.</p>
                  </li>

                </ul>

              </div>
            </Col>
            <Col xs={12} lg={6} className="align-self-stretch">
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  height: "100%",
                }}
              >
                <div style={{ flex: 1.4, position: "relative", minHeight: 320 }}>
                  <SafeImage
                    src="/img/gallery/home-why-choose-one.webp"
                    alt="Siddhivinayak Infrastructure - Modern Living Space"
                    fill
                    sizes="(max-width: 991px) 100vw, 40vw"
                    style={{
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </div>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    position: "relative",
                  }}
                >
                  <SafeImage
                    src="/img/gallery/home-why-choose-two.webp"
                    alt="Siddhivinayak Infrastructure - Interior Design"
                    width={400}
                    height={300}
                    sizes="(max-width: 991px) 100vw, 25vw"
                    style={{
                      width: "100%",
                      height: "50%",
                      minHeight: 150,
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                  <SafeImage
                    src="/img/gallery/home-why-choose-three.webp"
                    alt="Siddhivinayak Infrastructure - Exterior View"
                    width={400}
                    height={300}
                    sizes="(max-width: 991px) 100vw, 25vw"
                    style={{
                      width: "100%",
                      height: "50%",
                      minHeight: 150,
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Why Homebuyers Trust Us */}

    </>
  );
}

export default AboutUsStyleTwo;